import connectedComponent from './HeaderItems';

export default connectedComponent;